import { SkeletonBox } from '@practium/ui';
import styles from '../../pages/ProductRequestsPage.module.css';

const TableSkeleton = () => (
	<div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', padding: '0.5rem 0' }}>
		{Array.from({ length: 6 }).map((_, i) => (
			<SkeletonBox key={i} height="2.75rem" borderRadius="0.5rem" />
		))}
	</div>
);

export const ProductRequestsPageSkeleton = () => (
	<div className={styles.page}>
		<div className={styles.backButtonWrapper}>
			<SkeletonBox height="2.25rem" width="5.5rem" borderRadius="0.5rem" />
		</div>
		<div className={styles.contentWrapper}>
			<div className={styles.pageHeader}>
				<div className={styles.pageHeaderLeft}>
					<SkeletonBox height="1.875rem" width="14rem" borderRadius="0.25rem" />
					<SkeletonBox height="1rem" width="20rem" borderRadius="0.25rem" />
				</div>
				<SkeletonBox height="2.625rem" width="7rem" borderRadius="0.6rem" />
			</div>

			<div className={styles.card}>
				<div className={styles.tabsWrapper} style={{ gap: '0.5rem', padding: '0 0.25rem' }}>
					{Array.from({ length: 4 }).map((_, i) => (
						<SkeletonBox key={i} height="2rem" width="5.5rem" borderRadius="0.25rem" />
					))}
				</div>

				<div className={styles.filterRow}>
					<SkeletonBox height="2.25rem" style={{ flex: 1, maxWidth: '25rem' }} borderRadius="0.5rem" />
					<SkeletonBox height="2.25rem" width="2.625rem" borderRadius="0.5rem" />
					<SkeletonBox height="2.25rem" width="6rem" borderRadius="0.5rem" />
				</div>

				<div className={styles.tableContent}>
					<TableSkeleton />
				</div>

				<div className={styles.paginationRow}>
					<SkeletonBox height="2rem" width="10rem" borderRadius="0.5rem" />
				</div>
			</div>
		</div>
	</div>
);
